import { render, staticRenderFns } from "./Webapp.vue?vue&type=template&id=8163baf2&"
import script from "./Webapp.vue?vue&type=script&lang=js&"
export * from "./Webapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8163baf2')) {
      api.createRecord('8163baf2', component.options)
    } else {
      api.reload('8163baf2', component.options)
    }
    module.hot.accept("./Webapp.vue?vue&type=template&id=8163baf2&", function () {
      api.rerender('8163baf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Webapp.vue"
export default component.exports